import { ExportState } from '@mews-commander/data-access';
import { useAppClockService, useTimezone } from '@mews/framework';
import { addDaysUtc } from '@mews-commander/utils';
import { useCurrentProfileId } from '@mews-commander/core';
import { FilterValueKey } from '../constants';

export const useDefaultFilterValues = () => {
    const appClockService = useAppClockService();
    const timezone = useTimezone();
    const today = appClockService.getAppNowUtc().value;
    const todayMinusSevenDays = addDaysUtc({ utc: today, timezone, dayCount: -7 });
    const ownerProfileId = useCurrentProfileId();

    return {
        [FilterValueKey.startDate]: todayMinusSevenDays,
        [FilterValueKey.endDate]: today,
        [FilterValueKey.states]: Object.values(ExportState),
        [FilterValueKey.reportType]: null,
        [FilterValueKey.ownerProfileId]: ownerProfileId,
    };
};
